import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import MaterialsHero from "../sections/MaterialsHero";
import LocationHierarchy from "../sections/LocationHierarchy";
import PriceCard from "../sections/PriceCard";
import TransparencyGrid from "../sections/TransparencyGrid";
import QuoteAnalyzer from "../sections/QuoteAnalyzer";
import FinishesSpecBand from "../sections/FinishesSpecBand";
import MaterialsClosing from "../sections/MaterialsClosing";

const MaterialsPage = () => (
    <div className="min-h-screen bg-ink text-white">
        <Seo
            title="Materials Intelligence — Verified Material Pricing | BuildEase"
            description="Location-based construction material pricing with sources, dates and units shown — verified before displayed, never guessed."
        />
        <Navbar />
        <main>
            <MaterialsHero />
            <LocationHierarchy />
            <PriceCard />
            <TransparencyGrid />
            <QuoteAnalyzer />
            <FinishesSpecBand />
            <MaterialsClosing />
        </main>
        <Footer />
    </div>
);

export default MaterialsPage;
